import { z } from 'zod';
// =========================================================
// PIN-based authentication para los operadores/choferes de las
// autocargables Fiori (rol OperadorFiori). A diferencia del PIN de
// Laboratorio (uno solo, compartido), acá CADA operador tiene su propio
// PIN de 4 dígitos y su propia identidad — necesario para que cada uno
// vea solo las coladas que él mismo registró.
// =========================================================
const PIN_REGEX = /^\d{4}$/;
/** Fila pública para el selector de `/fiori-login` — nunca expone el PIN. */
export const OperadorFioriPublicoSchema = z.object({
    id: z.number().int().positive(),
    nombre: z.string(),
});
export const ListaOperadoresFioriPublicosResponseSchema = z.object({
    operadores: z.array(OperadorFioriPublicoSchema),
});
export const LoginFioriPinRequestSchema = z.object({
    id_operador: z.coerce.number().int().positive(),
    pin: z.string().regex(PIN_REGEX, 'El PIN debe ser exactamente 4 dígitos numéricos'),
});
export const LoginFioriPinResponseSchema = z.object({
    token: z.string(),
    nombre: z.string(),
    expira_en: z.number().int(),
});
/** Vista admin de un operador — sin PIN ni hash. */
export const OperadorFioriAdminSchema = z.object({
    id: z.number().int().positive(),
    nombre: z.string(),
    activo: z.boolean(),
    creado_en: z.string(),
    ultimo_uso_en: z.string().nullable(),
    bloqueado_hasta: z.string().nullable(),
    intentos_fallidos: z.number().int(),
});
export const ListaOperadoresFioriAdminResponseSchema = z.object({
    operadores: z.array(OperadorFioriAdminSchema),
});
export const CrearOperadorFioriRequestSchema = z.object({
    nombre: z.string().trim().min(1).max(100),
    pin: z.string().regex(PIN_REGEX, 'El PIN debe ser exactamente 4 dígitos numéricos'),
});
export const RotarPinOperadorFioriRequestSchema = z.object({
    pin: z.string().regex(PIN_REGEX, 'El PIN debe ser exactamente 4 dígitos numéricos'),
});
export const CambiarActivoOperadorFioriRequestSchema = z.object({
    activo: z.boolean(),
});
//# sourceMappingURL=fiori-operadores.js.map